import { render, staticRenderFns } from "./entity-card-user-management-roles-detail-general-information.vue?vue&type=template&id=a803dd46&"
import script from "./entity-card-user-management-roles-detail-general-information.vue?vue&type=script&lang=js&"
export * from "./entity-card-user-management-roles-detail-general-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports